module.exports = "/images/80e26a1f98e6d9b9e506a164f145a891.svg";